export enum NumericSeparator {
  Comma = ',',
  Period = '.',
  None = ''
}
